import { useEffect } from "react";

const RedirectTo = ({ href }: { href: string }) => {
    useEffect(() => {
        window.location.href = href;
    }, [])
    return null;
};

export default RedirectTo;
